import request from '@/utils/request'
//获取table表格数据
export function getList (data) {
  return request({
    url: `/firstRecord/page`,
    method: 'post',
    data,
  })
}
//获取所有老师
export function getTeachers () {
  return request({
    url: `schedule/teacherDiagnosisList`,
    method: 'get',
  })
}

export function getTeachers_s () {
  return request({
    url: `schedule/teacherAllList`,
    method: 'get',
  })
}



export function getTeachers_sss () {
  return request({
    url: `diagnoseTeacher/findList`,
    method: 'get',
  })
}

export function getTeachers_ssss () {
  return request({
    url: `projectTeacher/findList`,
    method: 'get',
  })
}

export function getTeachers_ss () {
  return request({
    url: `schedule/teacherDiagnosisList`,
    method: 'get',
  })
}


export function getTeachers_ssA () {
  return request({
    url: `schedule/teacherDiagnosisList`,
    method: 'get',
  })
}

//获取所有学生
export function getStudents () {
  return request({
    url: `student/getStudentList`,
    method: 'get',
  })
}

export function getStudentscopy (data) {
  return request({
    url: `student/getStudentList`,
    method: 'post',
    data
  })
}


export function getStudentsType (type) {
  return request({
    url: `student/getStudentList`,
    method: 'post',
    data:{
      studentType: type,
    }
  })
}

//修改首次课成功情况
export function changeFirstClass (data) {
  return request({
    url: `/firstRecord/update`,
    method: 'post',
    data
  })
}
//修改销售完成情况
export function markeStatus (data) {
  return request({
    url: `/firstRecord/marketOver?id=${data.id}&status=${data.marketSuccess}&url=${data.url}`,
    method: 'get',
  })
}
//获取所有科目
export function getSubject () {
  return request({
    url: `schedule/categorylist`,
    method: 'get',
  })
}
//详情
export function getdeta (id) {
  return request({
    url: `/firstRecord/detail/${id}`,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/firstClassApi.js